import React from 'react'

function PhoneField({ handleChange, phone, extension }) {
    return (
        <div className="input-group">
            <span className="input-group-text"><i className="fas fa-phone"></i></span>
            <input type="tel" data-inputmask="'mask': '+99'" data-greedy="false" name={extension.name} onChange={e => handleChange(e)}
                className="form-control extension" value={extension.value || ''} />
            <input type="tel" inputMode="numeric" data-greedy="false" placeholder='(999) 999-9999' name={phone.name} data-inputmask="'mask': '(999) 999-9999'" onChange={e => handleChange(e)}
                className="form-control" value={phone.value || ''} />
        </div>
    )
}

export default PhoneField
